import React from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { Pill } from '../Pill';
import { StageLayout } from '../StageLayout';
import { Portrait } from '../Portrait';
import { portraits } from '../../../data/tracking';
const BEATS = [300, 900, 1700, 2300];
const CONTRACT = ['30 seconds invested.', 'More control gained.', '12 minutes back.'];

/** The bonus. Time saved lands last, once the clinical case is made. */
export function Page7Bonus() {
  const beat = useBeats(BEATS);
  return <StageLayout centered bleed={<div className="h-full w-full opacity-0-init animate-fade-in" data-id="element-231" data-mp="1r71j5i68iutl">
          <Portrait src={portraits.peers.image} alt={portraits.peers.alt} data-id="element-232" data-mp="1d7ac61e4yep3" />
        </div>} copy={<>
          <p className={`font-body text-xs text-white/45 transition-opacity duration-300 ease-out md:text-sm ${beat >= 1 ? 'opacity-100' : 'opacity-0'}`} data-id="element-233" data-mp="1h7u8j2qvxea6">
            And there’s another payoff.
          </p>

          <div className={`mt-2 transition-[opacity,transform] duration-300 ease-out ${beat >= 2 ? 'translate-y-0 scale-100 opacity-100' : 'translate-y-2 scale-[0.96] opacity-0'}`} data-id="element-234" data-mp="349ec4911h4g4">
            <p className="max-w-[380px] font-headline text-[38px] font-extrabold leading-[0.95] tracking-tight text-solventum-primary md:text-[60px]" data-id="element-235" data-mp="390w96lzxykvt">
              12 MINUTES BACK
            </p>
            <p className="mt-2 font-body text-xs text-white/50 md:text-sm" data-id="element-236" data-mp="2gc8kshjwbfe1">
              saved per bonding procedure, on average
            </p>
          </div>

          <ul className={`mt-5 space-y-0.5 border-l border-solventum-primary/40 pl-4 transition-[opacity,transform] duration-300 ease-out ${beat >= 3 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-237" data-mp="2vb2l45w9g4n5">
            {CONTRACT.map(line => <li key={line} className="font-body text-sm text-white/75 md:text-base" data-id="element-238" data-mp="5jw8454gjahk">
                {line}
              </li>)}
          </ul>

          <div className={`mt-6 flex flex-wrap items-center gap-4 transition-[opacity,transform] duration-200 ease-out ${beat >= 4 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-239" data-mp="hkm740fsefl1">
            <Pill onClick={() => undefined} tone="accent" className="px-5" data-id="element-240" data-mp="3q2sclcean1on">
              See Precision Grip
            </Pill>
            <button onClick={() => undefined} className="font-body text-xs text-white/45 underline decoration-white/20 underline-offset-4 transition-colors duration-150 ease-out hover:text-white/80" data-id="element-241" data-mp="3v24xvspio0p4">
              Explore the evidence
            </button>
          </div>
        </>} data-id="element-230" data-mp="1r69rujjo7j94" />;
}